import BadgerAccordion from 'badger-accordion';
import { Component } from '../core/component';

export class Accordion extends Component {
    constructor() {
        super();
        this.selector = '.js-accordion';
    }

    init() {
        /* eslint-disable no-unused-vars */
        this.$elements.each((index, element) => {
            /* eslint-disable no-unused-vars */
            const accordion = new BadgerAccordion(element, {
                headerClass: '.js-accordion-header',
                openMultiplePanels: true,
                panelClass: '.js-accordion-panel',
                panelInnerClass: '.js-accordion-panel-inner',
                hiddenClass: 'is-hidden',
                activeClass: 'is-active',
                initializedClass: 'is-initialized',
            });
        });
    }
}



// WEBPACK FOOTER //
// ./assets/js/components/accordion.js